import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16.8126 3.0198L12.6787 5.27884L16.9056 7.58686V14.5298L21.0599 16.8865V5.27884L16.8126 3.0198Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.6787 18.4196V13.9797L21.0646 18.695L17.1788 20.9169L12.6787 18.4196Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.46202 20.917L11.5959 18.6579L7.36901 16.3499L7.36902 9.40696L3.21465 7.05028L3.21465 18.6579L7.46202 20.917Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.5959 5.5171V9.95702L3.20996 5.24166L7.09576 3.01978L11.5959 5.5171Z"}}]};

const LogoHiflowFilled = Vue.extend<IconProps>({
  name: 'LogoHiflowFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'logo-hiflow-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LogoHiflowFilled;
